import { THEMES, Theme } from '../themes/themes';
import { CountryAlpha3Code } from './countries';
import { countriesByAlpha3Code } from './countriesHelpers';

const enum Priority {
  Primary = 'Primary'
}

export type CountriesByPriority = Record<Priority, CountryAlpha3Code[]>;

const defaultPrimaryAlpha3List = [CountryAlpha3Code.AUS, CountryAlpha3Code.USA, CountryAlpha3Code.GBR];
const singaporePrimaryAlpha3List = [CountryAlpha3Code.SGP, CountryAlpha3Code.USA, CountryAlpha3Code.AUS, CountryAlpha3Code.HKG, CountryAlpha3Code.GBR];

export const COUNTRY_PRIORITIES_BY_THEME: Partial<Record<Theme, CountriesByPriority>> = {
  [THEMES.CMC]: {
    [Priority.Primary]: defaultPrimaryAlpha3List
  },
  [THEMES.CMCSingapore]: {
    [Priority.Primary]: singaporePrimaryAlpha3List
  }
};

type ParsedCountry = {
  primaryList: CountryAlpha3Code[];
  secondaryList: CountryAlpha3Code[];
};

const DEFAULT_THEME = THEMES.CMC;

export const countriesGroupAndSortForTheme = (countries: CountryAlpha3Code[] | undefined, theme: Theme) => {
  const initial: ParsedCountry = {
    primaryList: [],
    secondaryList: []
  };
  const primaryContries = (COUNTRY_PRIORITIES_BY_THEME[theme] ?? COUNTRY_PRIORITIES_BY_THEME[DEFAULT_THEME])!.Primary;

  const parsed = (countries ?? []).reduce((acc, next) => {
    const isPrimaryCountry = primaryContries.includes(next);
    const target = isPrimaryCountry ? acc.primaryList : acc.secondaryList;
    target.push(next);
    return acc;
  }, initial);

  parsed.primaryList.sort((a, b) => primaryContries.indexOf(a) - primaryContries.indexOf(b));
  parsed.secondaryList.sort((a, b) => countriesByAlpha3Code[a].name.localeCompare(countriesByAlpha3Code[b].name));

  return parsed;
};
